export default {
  OFF_BLACK: "#040011",
  OFF_BLACK_2: "#0d2030",
  BLACK: "#000000",
  GRAY_1: "#2c2c2c",
  GRAY_2: "#606060",
  GRAY_3: "#c8c0c0",
  TEAL_1: "#004058",
  TEAL_2: "#008894",
  TEAL_3: "#01e8e4",
  TEAL_4: "#01f8fc",
  SEA_GREEN_1: "#005800",
  SEA_GREEN_2: "#00a848",
  SEA_GREEN_3: "#58f89c",
  SEA_GREEN_4: "#b0f0d8",
  GREEN_1: "#006800",
  GREEN_2: "#00a800",
  GREEN_3: "#58d858",
  GREEN_4: "#b8f878",
  FOREST_1: "#007800",
  FOREST_2: "#00b800",
  FOREST_3: "#bcf818",
  FOREST_4: "#dcf878",
  BROWN_1: "#503000",
  BROWN_2: "#ac8000",
  YELLOW_1: "#fcb800",
  YELLOW_2: "#fcd884",
  RUST: "#8c1800",
  ORANGE_1: "#e46018",
  ORANGE_2: "#fca048",
  ORANGE_3: "#fce0b4",
  RED: "#ac1000",
  LIGHT_ORANGE: "#fc3800",
  PEACH_1: "#fc7858",
  PEACH_2: "#f4d0b4",
  PINK_1: "#ac0028",
  PINK_2: "#e40060",
  PINK_3: "#fc589c",
  PINK_4: "#f4c0e0",
  MAGENTA_1: "#94008c",
  MAGENTA_2: "#dc00d4",
  MAGENTA_3: "#fc78fc",
  MAGENTA_4: "#fcb8fc",
  PURPLE_1: "#4028c4",
  PURPLE_2: "#6848fc",
  PURPLE_3: "#9c78fc",
  PURPLE_4: "#dcb8fc",
  BLUE_1: "#0000c4",
  BLUE_2: "#0088fc",
  BLUE_3: "#6888fc",
  BLUE_4: "#bcb8fc",
  BLUE_BOLD: "#0000fc",
  AQUA_1: "#0078fc",
  AQUA_2: "#38c0fc",
  AQUA_3: "#a4e8fc",
  LIGHT_GRAY_1: "#788084",
  LIGHT_GRAY_2: "#bcc0c4",
  EGGSHELL: "#fee9c4",
  WHITE: "#fcf8fc",
  DEEP_BLUE: "#22123b",
  DEEP_RED: "#360900",
  ARMY: "#9e9e5c",
  EARTH: "#824e00",
};